import React from "react";
import { Helmet } from "react-helmet-async";

/**
 * Reusable SEO head component with sensible defaults.
 */
export default function SEO({
  title = "HostMarket — La piazza dei professionisti degli affitti brevi",
  description = "HostMarket è la piazza digitale dei professionisti degli affitti brevi: property manager, fotografi, home stager, architetti, revenue manager, avvocati, commercialisti. Un prodotto dell'ecosistema Vita da Host.",
  path = "/",
  image = "https://customer-assets.emergentagent.com/job_3f6aeb0f-8e60-46a8-8f7a-3fc15749da5c/artifacts/11ug0vp8_cropped-HostMarket-nuovo.png",
  type = "website",
  keywords = "affitti brevi, property manager, home stager, fotografi, revenue manager, hostmarket, vita da host",
  jsonLd = null,
}) {
  const url = `https://www.hostmarket.it${path}`;
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={url} />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      <meta property="og:locale" content="it_IT" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
    </Helmet>
  );
}
